import Header from "./components/Header";
import Hero from "./components/Hero";
import OfferBanner from "./components/OfferBanner";
import StatsBar from "./components/StatsBar";
import Features from "./components/Features";
import NetworkChart from "./components/NetworkChart";
import Plans from "./components/Plans";
import Coverage from "./components/Coverage";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import WhatsAppFloating from "./components/WhatsAppFloating";

function App() {
  return (
    <div className="min-h-screen bg-hero-gradient">
      <Header />
      <Hero />
      <OfferBanner />
      <StatsBar />
      <NetworkChart />
      <Features />
      <Plans />
      <Coverage />
      <Contact />
      <Footer />
      <WhatsAppFloating />
    </div>
  );
}

export default App;